import { NgModule } from "@angular/core";
import { AddressStoreModule } from "@app/address/store/address-store.module";
import { ZoneStoreModule } from "@app/area/store/zone-store.module";
import { AuthStoreModule } from "@app/auth/store/auth-store.module";
import { CustomerPortalStoreModule } from "@app/customer-portal/store/customer-portal-store.module";
import { CustomerStoreModule } from "@app/customer/store/customer-store.module";
import { EntityStoreModule } from "@app/entity/store/entity-store.module";
import { ProjectsStoreModule } from "@app/project/store/projects-store.module";
import { RuleStoreModule } from "@app/rule/store/rule-store.module";
import { UserManagementStoreModule } from "@app/user/store/user-management-store.module";
import { EffectsModule } from "@ngrx/effects";
import { RouterStateSerializer, StoreRouterConnectingModule } from "@ngrx/router-store";
import { ActionReducer, MetaReducer, StoreModule } from "@ngrx/store";
// import { LocalStorageConfig, localStorageSync } from "ngrx-store-localstorage";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { RootStoreActions } from "./actions";
import { initialState } from "./app.state";
import { DialogEffects, LocalizerEffects, RouterEffects, SnackbarEffects } from "./effects";
import { CustomSnackbarComponent } from "./effects/snackbar.effects";
import { reducers, routerExtras } from "./reducers";
import { CustomSerializer } from "./router.state";

// export const sessionStorage = (reducer: ActionReducer<any>): ActionReducer<any> => {
//     const config: LocalStorageConfig = {
//         keys: ["routerReducer"],
//         rehydrate: true,
//         removeOnUndefined: true,
//     };

//     return localStorageSync(config)(reducer);
// };

const logout =
    (reducer: ActionReducer<any>): ActionReducer<any> =>
    (state, action) => {
        if (RootStoreActions.clearRootState.type === action.type) {
            return initialState;
        }
        return reducer(state, action);
    };

const metaReducers: MetaReducer<any>[] = [logout];

@NgModule({
    imports: [
        // CommonModule,
        AuthStoreModule,
        AddressStoreModule,
        EntityStoreModule,
        UserManagementStoreModule,
        CustomerStoreModule,
        ProjectsStoreModule,
        RuleStoreModule,
        ZoneStoreModule,
        CustomerPortalStoreModule,
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false,
            },
        }),
        StoreModule.forFeature("activeRoute", routerExtras),
        EffectsModule.forRoot([RouterEffects, SnackbarEffects, DialogEffects, LocalizerEffects]),
        StoreRouterConnectingModule.forRoot(),
        MatIconModule,
        CommonModule,
    ],
    declarations: [CustomSnackbarComponent],
    providers: [
        {
            provide: RouterStateSerializer,
            useClass: CustomSerializer,
        },
    ],
})
export class RootStoreModule {}
